import createModal from '../create-modal';
import AuthModal from './component';

// TODO: 리팩토링 -> 로그인, 비밀번호 찾기 페이지 분리

export const {
  open,
  hide,
} = createModal('steamup-auth-modal', AuthModal, { zIndex: 1000 });

interface OpenAuthModalProps {
  onSuccess?: () => void;
  onClose?: () => void;
  signup: boolean;
  gotoAuthRegister?: () =>void;
  gotoAuthReset?: () => void;
}
/** 별도 설정이 없다면 로그인으로 이동 signup이 참이면 유저 선택으로 이동 */
export const openAuthModal = (props: OpenAuthModalProps = { signup: false }) => {
  open(props);
};

export const hideAuthModal = () => {
  hide();
};

export const {
  open: testOpen,
  hide: testHide,
} = createModal('steamup-join-modal', AuthModal, { zIndex: 1000 });

interface OpenAuthJoinModalProps {
  onSuccess?: () => void;
  onClose?: () => void;
  signup: boolean;
  gotoAuthLogin?: () =>void;
  gotoAuthReset?: () => void;
}

export const openJoinModal = (props: OpenAuthJoinModalProps = { signup: true }) => {
  testOpen(props);
};

export const hideJoinModal = () => {
  testHide();
};

//

export const {
  open: resetOpen,
  hide: resetHide,
} = createModal('steamup-reset-modal', AuthModal, { zIndex: 1000 });

interface OpenAuthResetModalProps {
  onSuccess?: () => void;
  onClose?: () => void;
  signup: boolean; // check
  reset: boolean;
  gotoAuthLogin?: () =>void;
  gotoAuthRegister?: () => void;
  gotoAuthReset?: () => void;
}

export const openResetModal = (props: OpenAuthResetModalProps = { signup: false, reset: true }) => {
  resetOpen(props);
};

export const hideResetModal = () => {
  resetHide();
};
